/* eslint-disable strict */
/* global $ */

const body = $('body');

document.addEventListener('lazyloaded', () => {
  // eslint-disable-next-line strict

  'use strict';
});

function mobileMenu() {
  $('.siskin-burger').click(() => {
    $('body').toggleClass('siskin-head-open');
  });
}

function mobileSubmenu() {
  if ($(window).width() < 930) {
    $('.siskin-nav-trigger').click(function () {
      $(this).parent().toggleClass('siskin-nav-open');
    });
  }
}

function player() {
  'use strict';

  const player = $('.player');
  const playerAudio = $('.player-audio');
  const playerMedia = player.find('.post-media');
  const playerThumbnail = player.find('.post-image');
  const playerTitle = player.find('.post-title-link');

  const playerProgress = $('.player-progress');
  let playerSpeed = 1;
  let buttonEpisode;
  const buttonPlay = $('.player-button-play');
  const buttonBackward = $('.player-button-backward');
  const buttonForward = $('.player-button-forward');
  const buttonSpeed = $('.player-button-speed');
  const buttonClose = $('.player-button-close');
  const timeCurrent = $('.player-time-current');
  const timeDuration = $('.player-time-duration');
  const buttonDownload = $('.btn-download');
  const buttonTweet = $('.btn-tw');
  const buttonFb = $('.btn-fb');

  $('.viewport').on('click', '.js-play', function () {
    const clicked = $(this);
    const url = clicked.attr('data-url');
    const id = clicked.attr('data-id');

    if ($('.player-external').length) {
      body.addClass('player-opened');
    }

    if (id !== playerMedia.attr('data-id')) {
      // Change audio player url
      playerAudio.attr('src', url);

      // Change player thumbnail
      // playerThumbnail.attr('srcset','data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
      playerThumbnail.attr(
        'srcset',
        clicked.find('.post-image').attr('src'),
      );

      // Change player title

      playerTitle.text(
        clicked.closest('.post').find('.post-card-title').text(),
      );

      // Change button download link
      buttonDownload.attr('href', url);

      // Change button Facebook link
      buttonFb.attr('href', `https://www.facebook.com/sharer.php?u=${siteUrl}${clicked.closest('.post').find('.post-card-title a').attr('href')}`);

      // Change button twitter link
      buttonTweet.attr('href', `https://twitter.com/intent/tweet?url=${siteUrl}${clicked.closest('.post').find('.post-card-title a').attr('href')}`);

      // Make previous episode button pause
      $(`.post-${playerMedia.attr('data-id')}`)
        .find('.icon')
        .removeClass('icon-pause').addClass('icon-play');

      // Change player media id attribute
      playerMedia.attr('data-id', id);
      buttonPlay.attr('data-id', id);

      // Select current episode button
      buttonEpisode = $(`[data-id="${id}"]`).find('.icon-play');
    }

    if (playerAudio[0].paused) {
      const playPromise = playerAudio[0].play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Make clicked button pause
            clicked.find('.icon').removeClass('icon-play').addClass('icon-pause');
            // Make playing episode button pause
            if (buttonEpisode) {
              buttonEpisode.addClass('icon-pause');
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      playerAudio[0].pause();
      // Make clicked button play
      clicked.find('.icon').removeClass('icon-pause').addClass('icon-play');
      // Make paused episode button play
      if (buttonEpisode) {
        buttonEpisode.removeClass('icon-pause').addClass('icon-play');
      }
    }
  });

  playerAudio.on('loadedmetadata', () => {
    timeDuration.text(
      new Date(playerAudio[0].duration * 1000).toISOString().substr(11, 8),
    );
    playerAudio[0].addEventListener('timeupdate', (e) => {
      timeCurrent.text(
        new Date(e.target.currentTime * 1000)
          .toISOString()
          .substr(11, 8),
      );
      playerProgress.css(
        'width',
        `${(e.target.currentTime / playerAudio[0].duration) * 100}%`,
      );
    });
  });

  buttonBackward.on('click', () => {
    playerAudio[0].currentTime -= 10;
  });

  buttonForward.on('click', () => {
    playerAudio[0].currentTime += 30;
  });

  buttonSpeed.on('click', () => {
    if (playerSpeed < 2) {
      playerSpeed += 0.5;
    } else {
      playerSpeed = 1;
    }

    playerAudio[0].playbackRate = playerSpeed;
    buttonSpeed.text(`${playerSpeed}x`);
  });
}

$(() => {
  'use strict';

  player();
  mobileMenu();
  mobileSubmenu();
});

$(window).resize(() => {
  mobileSubmenu();
});
